import React from "react";
import { Form, Select } from "semantic-ui-react";
import DateTimePicker from "../../../components/DateTimePicker";

function EmailScheduleSendOptionForm({
  timeZone,
  timeZones,
  runOnce,
  runUntil,
  runContinuously,
  runDateLimit,
  runDateLimitTimeZone,
  onScheduleOptionChange,
  onRunDateLimitChange,
  onRunDateLimitTimeZoneChange,
  error,
}) {
  const handleCheck = (data, value) => {
    onScheduleOptionChange(value.name);
  };

  const handleDateChange = value => {
    onRunDateLimitChange(value);
  };

  const handleTimeZoneChange = value => {
    onRunDateLimitTimeZoneChange(value);
  };

  return (
    <Form.Group grouped style={{ alignItems: "flex-start" }}>
      <Form.Group inline style={{ margin: 0 }}>
        <Form.Field label="Email Schedule Option" required />
        <Form.Radio
          label="Run Continuously"
          name="continuous"
          checked={runContinuously}
          onChange={handleCheck}
        />
        <Form.Radio
          label="Run Once"
          name="once"
          checked={runOnce}
          onChange={handleCheck}
        />
        <Form.Radio
          label="Run Until"
          name="date"
          checked={runUntil}
          onChange={handleCheck}
        />
      </Form.Group>
      {runUntil && (
        <Form.Group inline style={{ paddingTop: "1em" }}>
          <DateTimePicker
            required={true}
            name="emailDateLimit"
            label="Schedule Time & Date Limit"
            dateTime={runDateLimit}
            timeZone={runDateLimitTimeZone || timeZone}
            dateFormat="YYYY-MM-DD"
            style={{ marginTop: "0.5em", marginLeft: "1em", width: "250px" }}
            setDateTime={handleDateChange}
            error={error}
          />
          <Form.Field
            style={{ marginTop: "0.5em", marginLeft: "1em", flex: 1 }}
          >
            <label style={{ display: "block" }}>Time Zone</label>
            <Select
              search
              value={runDateLimitTimeZone || timeZone}
              options={timeZones}
              onChange={(_, { value: timeZone }) =>
                handleTimeZoneChange(timeZone)
              }
              placeholder="Select timezone"
            />
          </Form.Field>
        </Form.Group>
      )}
    </Form.Group>
  );
}

export default EmailScheduleSendOptionForm;
